module.exports = __webpack_public_path__ + "static/media/Download-Report.f31aa43f.jpg";